import React from "react";

const Input = ({ name, label, error, headerTextColor, ...rest }) => {
  return (
    <div className="form-group" style={{ color: "white", textAlign: "left" }}>
      <label htmlFor={name} style={{ color: headerTextColor }}>
        {label}
      </label>
      <input {...rest} name={name} id={name} className="form-control" />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;
